import $ from "jquery";

let lazyPictures = [];

function addLazy() {
  lazyPictures = [...lazyPictures, ...[].slice.call($("picture.lazy"))];
}

function manageLaziness(lazyPicture) {
  const $lazyPicture = $(lazyPicture);
  const $lazyImage = $lazyPicture.find("img");
  $lazyImage.src = $lazyImage.data("src");
  const $lazySources = $lazyPicture.find("source");

  $lazySources.each((_, lazySource) => {
    lazySource.srcset = lazySource.getAttribute("data-srcset");
  });

  $lazyImage.on("load", () => $lazyPicture.removeClass("lazy"));
}

function run() {
  addLazy();
  if ("IntersectionObserver" in window) {
    const lazyImageObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const lazyPicture = entry.target;
        manageLaziness(lazyPicture);
        lazyImageObserver.unobserve(lazyPicture);
      });
    });

    lazyPictures.forEach((lazyPicture) =>
      lazyImageObserver.observe(lazyPicture),
    );
  } else {
    const lazyFallback = () => {
      lazyPictures.forEach((lazyPicture) => {
        if (
          // eslint-disable-next-line no-undef
          lazyPicture.getBoundingClientRect().top <= w.innerHeight &&
          lazyPicture.getBoundingClientRect().bottom >= 0 &&
          getComputedStyle(lazyPicture).display !== "none"
        ) {
          manageLaziness(lazyPicture);
        }
      });
      if ($("picture.lazy").length) {
        requestAnimationFrame(lazyFallback);
      }
    };
    requestAnimationFrame(lazyFallback);
  }
}

function initLazyload() {
  run();
  $(window).on("lazy-content-loaded", () => run());
}

export default initLazyload;

export const lazyLoadImage = (lazyPicture) => {
  return manageLaziness(lazyPicture);
};
